import { LanguageStrings } from './base-strings';

export const hr: LanguageStrings = {
  /** Routes */
  'routes.home': '/',
  'routes.summary': '/sazetak',

  /** Page content */
  'home.title': 'Početna',
  'home.content':
    'Hvala vam što ste posjetili ovaj primjer višejezičnog routinga.',

  'summary.title': 'Sažetak',
  'summary.content': 'Pročitajte više o članku na {medium} ili {devto}.',

  'error.title': 'Greška',
  'error.content':
    'Ova stranice je otišla na godišnji odmor. Pokušajte ponovo kasnije.',

  /** Links */
  'links.medium':
    'https://medium.com/prototyped/multi-language-routing-in-react-d7eb7a0688e9',
  'links.dev.to': 'https://dev.to/prototyp/multi-language-routing-in-react-k9l'
};
